import api from "./apiClient.js";

const endpoint = "allarmeteo";

export const getAllAllarmeteo = () => {
	return api.get(endpoint);
};
export const getValidAllarmeteo = () => {
	return api.get(endpoint + "/valid");
};

export const downloadAlertImage = async (id) => {
	return api.get(
		`${endpoint}/${id}/image`,
		{},
		{
			responseType: "arraybuffer",
		}
	);
};
